export default __webpack_public_path__ + "assets/images/5ba31acb20f6b3b281d9f55b2c0d31e0.png";